<div class="sample-container" style="margin-top: 4em;">
  <div class="container-fluid">
    <div class="checkout-tabs position-relative">

      <div class="ck-layout">
        <div class="ck-main">
          <ul ngbNav #nav="ngbNav" [activeId]="activeTab" [animation]="false" class="ck-steps">

            <li [ngbNavItem]="1" [disabled]="true" class="ck-step" [class.ck-step--done]="activeTab > 1">
              <a (click)="setTab(1)" ngbNavLink data-step="01" [attr.aria-current]="activeTab == 1 ? 'step' : null">
                <div class="ck-step__dot">
                  <i *ngIf="activeTab > 1" class="bx bx-check"></i>
                  <ng-container *ngIf="activeTab <= 1">1</ng-container>
                </div>
                <div class="ck-step__label">Tus datos</div>
              </a>
              <ng-template ngbNavContent>
                <div class="corp-card">
                  <div class="corp-card-header">
                    <div class="corp-step-badge">Paso 1 de 4</div>
                    <h4 class="corp-card-title">Tus datos</h4>
                    <p class="corp-card-subtitle">Revisa que tus datos estén correctos y elige cómo vas a pagar.</p>
                  </div>
                  <div class="corp-card-body">
                    <form [formGroup]="checkoutForm">
                      <div class="corp-form-row" [class.ck-cargando]="cargandoDatos" [attr.aria-busy]="cargandoDatos">

                        <div class="corp-form-group corp-form-col-4">
                          <label for="billing-name" class="corp-label">
                            <i class="bx bx-user corp-label-icon"></i> Nombre
                          </label>
                          <input type="text" class="corp-input" id="billing-name"
                            placeholder="Ingresa tu nombre completo"
                            formControlName="billingName">
                          <div *ngIf="checkoutForm.get('billingName').touched && checkoutForm.get('billingName').invalid"
                            class="corp-error">
                            <i class="bx bx-error-circle"></i> Nombre es obligatorio
                          </div>
                        </div>

                        <div class="corp-form-group corp-form-col-4">
                          <label for="billing-email-address" class="corp-label">
                            <i class="bx bx-envelope corp-label-icon"></i> Correo Electrónico
                          </label>
                          <input type="email" class="corp-input" id="billing-email-address"
                            placeholder="correo@ejemplo.com"
                            formControlName="billingEmail">
                          <div *ngIf="checkoutForm.get('billingEmail').touched && checkoutForm.get('billingEmail').invalid"
                            class="corp-error">
                            <i class="bx bx-error-circle"></i> Dirección de correo electrónico inválida
                          </div>
                        </div>

                        <div class="corp-form-group corp-form-col-4">
                          <label for="billing-phone" class="corp-label">
                            <i class="bx bx-phone corp-label-icon"></i> Teléfono
                          </label>
                          <input type="text" class="corp-input" id="billing-phone"
                            placeholder="Ingresa tu número de teléfono"
                            formControlName="billingPhone">
                          <div *ngIf="checkoutForm.get('billingPhone').touched && checkoutForm.get('billingPhone').invalid"
                            class="corp-error">
                            <i class="bx bx-error-circle"></i> Teléfono solo debe contener números
                          </div>
                        </div>

                        <div class="corp-form-group corp-form-col-4">
                          <label class="corp-label">
                            <i class="bx bx-globe corp-label-icon"></i> País
                          </label>
                          <ng-select [items]="selectValue" formControlName="country"
                            bindLabel="label" bindValue="value"
                            class="corp-select"></ng-select>
                          <div *ngIf="checkoutForm.get('country').touched && checkoutForm.get('country').invalid"
                            class="corp-error">
                            <i class="bx bx-error-circle"></i> País es obligatorio
                          </div>
                        </div>

                        <div class="corp-form-group corp-form-col-8">
                          <label for="billing-address" class="corp-label">
                            <i class="bx bx-map corp-label-icon"></i> Dirección
                          </label>
                          <textarea class="corp-input corp-textarea" id="billing-address" rows="1"
                            placeholder="Ingresa la dirección completa"
                            formControlName="billingAddress"></textarea>
                          <div *ngIf="checkoutForm.get('billingAddress').touched && checkoutForm.get('billingAddress').invalid"
                            class="corp-error">
                            <i class="bx bx-error-circle"></i> Dirección es obligatoria
                          </div>
                        </div>

                      </div>
                    </form>

                    <div class="corp-section-divider">
                      <span>Método de Pago</span>
                    </div>

                    <div class="corp-payment-grid" *ngIf="cargandoMetodos" aria-busy="true">
                      <div class="payment-option" *ngFor="let n of [1, 2, 3]">
                        <div class="payment-card ck-esqueleto"></div>
                        <div class="ck-esqueleto ck-esqueleto--texto"></div>
                      </div>
                    </div>
                    <div class="ck-vacio" *ngIf="!cargandoMetodos && lstTiposPago.length == 0">
                      No hay métodos de pago configurados para tu institución. Comunícate con el área financiera.
                    </div>
                    <div class="corp-payment-grid" *ngIf="!cargandoMetodos">
                      <div *ngFor="let pago of lstTiposPago; let i = index" class="payment-option">
                        <input (change)="seleccionarContrato()" class="form-check-input" type="radio"
                          name="paymentoptionsRadio" id="paymentoptionsRadio{{i}}"
                          value="{{pago.FUENTE}}" [(ngModel)]="metodoPagoSeleccionado"
                          style="display: none;">
                        <label class="payment-logo" for="paymentoptionsRadio{{i}}">
                          <div class="payment-card">
                            <img *ngIf="hasLogo(pago.LOGO)"
                              [src]="'data:image/*;base64,' + pago.LOGO"
                              [alt]="pago.FUENTE || 'Logo'"
                              class="payment-img">
                            <img *ngIf="!hasLogo(pago.LOGO)"
                              src="assets/images/default-credit-card.png"
                              [alt]="pago.FUENTE || 'Logo'"
                              class="payment-img">
                          </div>
                          <span class="payment-name">{{pago.DESCRIPCION}}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="corp-nav-actions">
                  <div></div>
                  <button type="button" class="corp-btn corp-btn-primary"
                    (click)="nextTab()" [disabled]="checkoutForm.invalid || !metodoPagoSeleccionado">
                    Continuar <i class="mdi mdi-chevron-right"></i>
                  </button>
                </div>
              </ng-template>
            </li>

            <li [ngbNavItem]="2" [disabled]="true" class="ck-step" [class.ck-step--done]="activeTab > 2">
              <a (click)="setTab(2)" ngbNavLink data-step="02" [attr.aria-current]="activeTab == 2 ? 'step' : null">
                <div class="ck-step__dot">
                  <i *ngIf="activeTab > 2" class="bx bx-check"></i>
                  <ng-container *ngIf="activeTab <= 2">2</ng-container>
                </div>
                <div class="ck-step__label">Términos</div>
              </a>
              <ng-template ngbNavContent>
                <div class="corp-card">
                  <div class="corp-card-header">
                    <div class="corp-step-badge">Paso 2 de 4</div>
                    <h4 class="corp-card-title">Términos y condiciones</h4>
                    <p class="corp-card-subtitle">Lee el contrato del método de pago y acéptalo para continuar.</p>
                  </div>
                  <div class="corp-card-body">
                    <div class="corp-tyc-container">
                      <iframe *ngIf="metodoPagoSeleccionado != 'WPI'" [src]="link_contrato"
                        width="100%" class="corp-iframe ck-visor" title="Términos y condiciones"></iframe>
                      <a *ngIf="metodoPagoSeleccionado != 'WPI' && descargaContrato" [href]="descargaContrato"
                        download="terminos-y-condiciones.pdf" class="ck-link-descarga">
                        <i class="bx bx-download"></i> Descargar PDF
                      </a>
                      <button *ngIf="metodoPagoSeleccionado == 'WPI'"
                        class="wompi-pastel-btn" (click)="abrirTerminosWompi()">
                        <svg class="icono-doc" width="22" height="22" viewBox="0 0 22 22" fill="none">
                          <rect x="4" y="3" width="12" height="16" rx="2" fill="#fff"
                            stroke="#222222" stroke-width="2" />
                          <rect x="7" y="7" width="6" height="1.5" rx="0.75" fill="#b6eaff" />
                          <rect x="7" y="10" width="6" height="1.5" rx="0.75" fill="#b6eaff" />
                          <rect x="7" y="13" width="4" height="1.5" rx="0.75" fill="#b6eaff" />
                        </svg>
                        Ver Términos y Condiciones
                      </button>
                    </div>

                    <div class="form-check mt-3 ck-acepta" [class.ck-acepta--ok]="AceptaTerminos">
                      <input class="form-check-input" type="checkbox" id="aceptaTerminos"
                        [(ngModel)]="AceptaTerminos">
                      <label class="form-check-label" for="aceptaTerminos">
                        He leído y acepto los Términos y Condiciones
                      </label>
                    </div>
                  </div>
                </div>

                <div class="corp-nav-actions">
                  <a href="javascript:void(0);" class="corp-btn corp-btn-ghost" (click)="prevTab()">
                    <i class="mdi mdi-chevron-left"></i> Volver
                  </a>
                  <button type="button" class="corp-btn corp-btn-primary"
                    (click)="nextTab()" [disabled]="!AceptaTerminos || !transaccion">
                    Aceptar y continuar <i class="mdi mdi-chevron-right"></i>
                  </button>
                </div>
              </ng-template>
            </li>

            <li [ngbNavItem]="3" [disabled]="true" class="ck-step" [class.ck-step--done]="activeTab > 3">
              <a (click)="setTab(3)" ngbNavLink data-step="03" [attr.aria-current]="activeTab == 3 ? 'step' : null">
                <div class="ck-step__dot">
                  <i *ngIf="activeTab > 3" class="bx bx-check"></i>
                  <ng-container *ngIf="activeTab <= 3">3</ng-container>
                </div>
                <div class="ck-step__label">Pago</div>
              </a>
              <ng-template ngbNavContent>
                <div class="corp-card">
                  <div class="corp-card-header">
                    <div class="corp-step-badge">Paso 3 de 4</div>
                    <!-- <h4 class="corp-card-title">Datos de la tarjeta</h4> -->
                    <!-- mospina 10-10-16 EPT-2563 SCG-459 Integracion Yappy -->
                    <h4 class="corp-card-title">{{ esPagoApp ? 'Pago con Yappy' : 'Datos de la tarjeta' }}</h4>
                    <p *ngIf="requiereTarjeta"
                      class="corp-card-subtitle">Escribe los datos de tu tarjeta. El cobro se hace en el siguiente paso.</p>
                    <p *ngIf="esRedireccion"
                      class="corp-card-subtitle">Los datos de pago serán ingresados de forma segura en el siguiente paso a través del portal de pago.</p>
                    <!-- mospina 10-10-16 EPT-2563 SCG-459 Integracion Yappy -->
                    <p *ngIf="esPagoApp"
                      class="corp-card-subtitle">Indica el celular de tu cuenta Yappy. El cobro se envía en el siguiente paso.</p>
                  </div>
                  <div class="corp-card-body">

                    <div class="corp-payment-grid" *ngIf="esRedireccion && metodoSeleccionadoInfo as pago">
                      <div class="payment-option">
                        <div class="payment-logo">
                          <div class="payment-card">
                            <img *ngIf="hasLogo(pago.LOGO)" [src]="'data:image/*;base64,' + pago.LOGO"
                              [alt]="pago.FUENTE || 'Logo'" class="payment-img">
                            <img *ngIf="!hasLogo(pago.LOGO)" src="assets/images/default-credit-card.png"
                              [alt]="pago.FUENTE || 'Logo'" class="payment-img">
                          </div>
                          <span class="payment-name">{{pago.DESCRIPCION}}</span>
                        </div>
                      </div>
                    </div>

                    <!-- mospina 10-10-16 EPT-2563 SCG-459 Integracion Yappy -->
                    <div *ngIf="esPagoApp" class="yap-panel">
                      <div class="yap-panel__marca">
                        <img *ngIf="metodoSeleccionadoInfo && hasLogo(metodoSeleccionadoInfo.LOGO)"
                          [src]="'data:image/*;base64,' + metodoSeleccionadoInfo.LOGO" alt="Yappy" class="yap-panel__logo">
                        <div>
                          <div class="yap-panel__titulo">Paga desde tu app Yappy</div>
                          <div class="yap-panel__texto">Te llegará una solicitud de pago al celular y tendrás 5 minutos para aprobarla en la app.</div>
                        </div>
                      </div>

                      <label class="pay-label" for="yappy-alias">Celular registrado en Yappy</label>
                      <div class="yap-alias" [class.yap-alias--error]="aliasYappy && !aliasYappyValido">
                        <span class="yap-alias__prefijo">+507</span>
                        <input id="yappy-alias" #aliasInput class="yap-alias__input" type="tel" inputmode="numeric"
                          maxlength="8" placeholder="60000000" autocomplete="off"
                          [value]="aliasYappy" (input)="onAliasYappy(aliasInput)">
                      </div>
                      <span class="pay-hint" *ngIf="!aliasYappy || aliasYappyValido">Debe ser el número asociado a tu cuenta Yappy (8 dígitos).</span>
                      <span class="pay-hint yap-hint-error" *ngIf="aliasYappy && !aliasYappyValido">El número debe tener 8 dígitos.</span>

                      <ol class="yap-pasos">
                        <li><span>1</span> Revisa el resumen y presiona el botón de Yappy.</li>
                        <li><span>2</span> Abre tu app Yappy y aprueba la solicitud.</li>
                        <li><span>3</span> Esta pantalla mostrará tu comprobante automáticamente.</li>
                      </ol>
                    </div>

                    <div *ngIf="requiereTarjeta" class="pay-layout">

                      <aside class="pay-side">
                        <div class="pay-card" [class.pay-card--reverso]="mostrarReverso" aria-hidden="true">
                          <div class="pay-card__inner">
                            <div class="pay-card__face pay-card__front">
                              <div class="pay-card__top">
                                <span class="pay-card__chip"></span>
                                <span class="pay-card__brand" [attr.data-marca]="marcaTarjeta">{{ nombreMarca }}</span>
                              </div>
                              <div class="pay-card__number">{{ numeroVista }}</div>
                              <div class="pay-card__bottom">
                                <div class="pay-card__field pay-card__field--name">
                                  <span class="pay-card__caption">Titular</span>
                                  <span class="pay-card__value">{{ cardForm.get('cardName')?.value || 'Nombre del titular' }}</span>
                                </div>
                                <div class="pay-card__field">
                                  <span class="pay-card__caption">Vence</span>
                                  <span class="pay-card__value">{{ cardForm.get('expiryDate')?.value || 'MM/AA' }}</span>
                                </div>
                              </div>
                            </div>
                            <div class="pay-card__face pay-card__back">
                              <div class="pay-card__stripe"></div>
                              <div class="pay-card__sign">
                                <span class="pay-card__cvv">{{ cvvVista }}</span>
                              </div>
                              <span class="pay-card__back-note">Código de seguridad</span>
                            </div>
                          </div>
                        </div>

                        <p class="pay-secure"><i class="bx bx-lock-alt"></i> Los datos de la tarjeta se envían cifrados al procesador de pago.</p>
                      </aside>

                      <form [formGroup]="cardForm" class="pay-form" autocomplete="on">
                        <div class="pay-field">
                          <label for="cardnumberInput" class="pay-label">Número de la tarjeta</label>
                          <div class="pay-input-wrap">
                            <input type="text" class="pay-input pay-input--number" id="cardnumberInput"
                              inputmode="numeric" autocomplete="cc-number"
                              placeholder="0000 0000 0000 0000"
                              formControlName="cardNumber"
                              (input)="formatCardNumber($event)"
                              (focus)="mostrarReverso = false"
                              maxlength="23" />
                            <span class="pay-input-brand" *ngIf="nombreMarca" [attr.data-marca]="marcaTarjeta">{{ nombreMarca }}</span>
                          </div>
                          <div *ngIf="cardForm.get('cardNumber')?.touched && cardForm.get('cardNumber')?.invalid" class="corp-error">
                            <i class="bx bx-error-circle"></i> Revisa el número: debe tener entre 13 y 19 dígitos.
                          </div>
                        </div>

                        <div class="pay-field">
                          <label for="cardnameInput" class="pay-label">Nombre del titular</label>
                          <input type="text" class="pay-input" id="cardnameInput"
                            autocomplete="cc-name"
                            placeholder="Como aparece en la tarjeta"
                            formControlName="cardName"
                            (focus)="mostrarReverso = false" />
                          <div *ngIf="cardForm.get('cardName')?.touched && cardForm.get('cardName')?.invalid" class="corp-error">
                            <i class="bx bx-error-circle"></i> Escribe el nombre del titular.
                          </div>
                        </div>

                        <div class="pay-row" [class.pay-row--cuotas]="metodoPagoSeleccionado == 'WPI'">
                          <div class="pay-field">
                            <label for="expirydateInput" class="pay-label">Vence</label>
                            <input type="text" class="pay-input" id="expirydateInput"
                              inputmode="numeric" autocomplete="cc-exp"
                              placeholder="MM/AA"
                              formControlName="expiryDate"
                              (input)="onExpiryDateInput($event)"
                              (focus)="mostrarReverso = false" />
                            <div *ngIf="cardForm.get('expiryDate')?.touched && cardForm.get('expiryDate')?.invalid" class="corp-error">
                              <i class="bx bx-error-circle"></i>
                              {{ cardForm.get('expiryDate')?.hasError('vencida') ? 'La tarjeta está vencida.' : 'Usa el formato MM/AA.' }}
                            </div>
                          </div>

                          <div class="pay-field">
                            <label for="cvvcodeInput" class="pay-label">Código de seguridad</label>
                            <input type="password" class="pay-input" id="cvvcodeInput"
                              inputmode="numeric" autocomplete="cc-csc"
                              placeholder="CVV"
                              formControlName="cvv"
                              (input)="onCVVInput($event)"
                              (focus)="mostrarReverso = true"
                              (blur)="mostrarReverso = false" />
                            <span class="pay-hint">3 o 4 dígitos al reverso</span>
                            <div *ngIf="cardForm.get('cvv')?.touched && cardForm.get('cvv')?.invalid" class="corp-error">
                              <i class="bx bx-error-circle"></i> El código tiene 3 o 4 dígitos.
                            </div>
                          </div>

                          <div class="pay-field" *ngIf="metodoPagoSeleccionado == 'WPI'">
                            <label for="installmentsInput" class="pay-label">Cuotas</label>
                            <select class="pay-input corp-select-native" id="installmentsInput" formControlName="installments">
                              <option value="1">1 cuota</option>
                              <option value="2">2 cuotas</option>
                              <option value="12">12 cuotas</option>
                              <option value="24">24 cuotas</option>
                            </select>
                            <div *ngIf="cardForm.get('installments')?.touched && cardForm.get('installments')?.invalid" class="corp-error">
                              <i class="bx bx-error-circle"></i> Elige el número de cuotas.
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>

                  </div>
                </div>

                <div class="corp-nav-actions">
                  <a href="javascript:void(0);" class="corp-btn corp-btn-ghost" (click)="prevTab()">
                    <i class="mdi mdi-chevron-left"></i> Volver
                  </a>
                  <button *ngIf="requiereTarjeta" type="button"
                    class="corp-btn corp-btn-primary"
                    (click)="nextTab()" [disabled]="cardForm.invalid">
                    Continuar <i class="mdi mdi-chevron-right"></i>
                  </button>
                  <button *ngIf="esRedireccion" type="button"
                    class="corp-btn corp-btn-primary"
                    (click)="nextTab()">
                    Continuar <i class="mdi mdi-chevron-right"></i>
                  </button>
                  <!-- mospina 10-10-16 EPT-2563 SCG-459 Integracion Yappy -->
                  <button *ngIf="esPagoApp" type="button"
                    class="corp-btn corp-btn-primary"
                    (click)="nextTab()" [disabled]="!aliasYappyValido">
                    Continuar <i class="mdi mdi-chevron-right"></i>
                  </button>
                </div>
              </ng-template>
            </li>

            <li [ngbNavItem]="4" [disabled]="true" class="ck-step" [class.ck-step--done]="activeTab > 4">
              <a (click)="setTab(4)" ngbNavLink data-step="04" [attr.aria-current]="activeTab == 4 ? 'step' : null">
                <div class="ck-step__dot">
                  <i *ngIf="activeTab > 4" class="bx bx-check"></i>
                  <ng-container *ngIf="activeTab <= 4">4</ng-container>
                </div>
                <div class="ck-step__label">Confirmación</div>
              </a>
              <ng-template ngbNavContent>

                <div class="corp-confirm-step" [class.d-none]="respuestaPagoGeneral">

                  <div class="corp-confirm-content">
                    <div class="corp-card">
                      <div class="corp-card-header">
                        <div class="corp-step-badge">Paso 4 de 4</div>
                        <h4 class="corp-card-title">Revisa y paga</h4>
                        <p class="corp-card-subtitle">Verifica los datos antes de confirmar el pago.</p>
                      </div>
                      <div class="corp-card-body">
                        <div class="ck-revision">
                          <div class="ck-revision__bloque">
                            <div class="ck-revision__titulo">Pagas como</div>
                            <div class="ck-revision__valor">{{ checkoutForm.get('billingName')?.value }}</div>
                            <div class="ck-revision__detalle">{{ checkoutForm.get('billingEmail')?.value }}</div>
                          </div>
                          <div class="ck-revision__bloque" *ngIf="metodoSeleccionadoInfo as pago">
                            <div class="ck-revision__titulo">Método de pago</div>
                            <div class="ck-revision__valor ck-revision__metodo">
                              <img *ngIf="hasLogo(pago.LOGO)" [src]="'data:image/*;base64,' + pago.LOGO" [alt]="pago.FUENTE || 'Logo'">
                              <div>{{ pago.DESCRIPCION }}</div>
                            </div>
                            <div class="ck-revision__detalle" *ngIf="requiereTarjeta && ultimosDigitos">Tarjeta •••• {{ ultimosDigitos }}</div>
                            <div class="ck-revision__detalle" *ngIf="esRedireccion">Terminarás el pago en el portal del banco.</div>
                            <!-- mospina 10-10-16 EPT-2563 SCG-459 Integracion Yappy -->
                            <div class="ck-revision__detalle" *ngIf="esPagoApp">Yappy · +507 {{ aliasYappy }}</div>
                          </div>
                          <div class="ck-revision__bloque">
                            <div class="ck-revision__titulo">Transacción</div>
                            <div class="ck-revision__valor">No. {{ transaccion }}</div>
                          </div>
                        </div>

                        <h5 class="corp-section-title">Conceptos a pagar</h5>
                        <div class="ck-conceptos">
                          <div class="ck-conceptos__cab">
                            <div>Concepto</div>
                            <div>Monto</div>
                          </div>
                          <div class="ck-conceptos__fila" *ngFor="let filtro of filtrosList; let i = index">
                            <div class="ck-conceptos__num">{{ i + 1 }}</div>
                            <div class="ck-conceptos__nombre">{{ filtro.M54DES }}</div>
                            <div class="ck-conceptos__monto">{{ simboloMoneda }}{{ formatearMoneda(filtro.M54MON) }}</div>
                          </div>
                          <div class="ck-conceptos__total">
                            <div class="ck-conceptos__total-label">Total a pagar</div>
                            <div class="ck-conceptos__total-monto">{{ simboloMoneda }}{{ totalMontoFormateado }}</div>
                          </div>
                        </div>

                        <div *ngIf="errores.length > 0" class="corp-alert corp-alert-danger">
                          <i class="bx bx-error-circle corp-alert-icon"></i>
                          <div>
                            <strong>Error, por favor complete los siguientes campos:</strong>
                            <ul class="corp-error-list">
                              <li *ngFor="let error of errores" [innerHTML]="error"></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- mospina 10-10-16 EPT-2565 SCG-459 Integracion Yappy -->
                  <div *ngIf="yappyEsperando" class="yap-espera" role="status" aria-live="polite">
                    <div class="yap-espera__icono"><i class="bx bx-mobile-vibration"></i></div>
                    <!-- mospina 10-10-16 EPT-2565 SCG-459 Integracion Yappy -->
                    <div class="yap-espera__texto" *ngIf="!yappyFinalizando">
                      <strong>Aprueba el pago en tu app Yappy</strong>
                      <span>Enviamos la solicitud al +507 {{ aliasYappy }}. Esta pantalla se actualiza sola cuando la apruebes.</span>
                    </div>
                    <div class="yap-espera__texto" *ngIf="yappyFinalizando">
                      <strong>Recibimos la respuesta de Yappy</strong>
                      <span>Estamos preparando tu comprobante…</span>
                    </div>
                    <div class="yap-espera__reloj" title="Tiempo restante" *ngIf="!yappyFinalizando">{{ relojYappy }}</div>
                  </div>

                  <div *ngIf="yappySinRespuesta" class="corp-alert corp-alert-warning yap-sin-respuesta">
                    <i class="bx bx-time-five corp-alert-icon"></i>
                    <div>
                      <strong>Aún no recibimos la confirmación de Yappy.</strong>
                      Si ya aprobaste el pago en la app, se aplicará en unos minutos; revisa tus pagos antes de intentar de nuevo.
                    </div>
                  </div>

                  <div class="corp-confirm-actions">
                    <!-- mospina 10-10-16 EPT-2565 SCG-459 Integracion Yappy: no se permite volver mientras se espera a Yappy -->
                    <a *ngIf="!yappyEsperando" href="javascript:void(0);" class="corp-btn corp-btn-ghost" (click)="prevTab()">
                      <i class="mdi mdi-chevron-left"></i> Volver
                    </a>
                    <div class="d-flex gap-2">
                      <button *ngIf="!terminarPago && !yappyEsperando" type="button" class="corp-btn corp-btn-danger"
                        (click)="onFinish()" [disabled]="procesando">
                        <i class="fas fa-times"></i> Cancelar Pago
                      </button>
                      <div *ngIf="esPagoApp" class="yap-boton" [class.d-none]="terminarPago"
                        [class.yap-boton--bloqueado]="procesando || yappyEsperando || yappyFinalizando">
                        <span *ngIf="yappyDisponible === null" class="yap-boton__cargando"><i class="bx bx-loader-alt bx-spin"></i> Cargando Yappy…</span>
                        <span *ngIf="yappyDisponible === false" class="yap-boton__nodisp"><i class="bx bx-error-circle"></i> Yappy no está disponible en este momento. Intenta más tarde.</span>
                        <btn-yappy #btnYappy theme="darkBlue" rounded="true" [class.yap-boton__oculto]="yappyDisponible !== true"></btn-yappy>
                      </div>
                      <button *ngIf="!terminarPago && !esPagoApp" type="button" class="corp-btn corp-btn-primary"
                        (click)="onPay()" [disabled]="procesando">
                        <i class="bx me-1" [ngClass]="procesando ? 'bx-loader-alt bx-spin' : 'bx-money'"></i>
                        {{ procesando ? 'Procesando...' : 'Pagar ' + simboloMoneda + totalMontoFormateado }}
                      </button>
                      <button *ngIf="terminarPago" class="corp-btn corp-btn-primary" (click)="onFinishPay()">
                        <i class="fas fa-check"></i> Finalizar Pago
                      </button>
                    </div>
                  </div>

                </div>

                <div *ngIf="respuestaPagoGeneral" class="corp-card ck-recibo">

                  <div *ngIf="comprobante as c" class="ck-recibo__cuerpo">
                    <div class="ck-recibo__estado" [ngClass]="c.aprobado ? 'ck-recibo__estado--ok' : 'ck-recibo__estado--error'">
                      <i class="bx" [ngClass]="c.aprobado ? 'bx-check' : 'bx-x'"></i>
                    </div>
                    <h4 class="ck-recibo__titulo">{{ c.aprobado ? 'Pago aprobado' : 'Pago rechazado' }}</h4>
                    <div class="ck-recibo__monto">{{ simboloDe(c.moneda) }}{{ formatearMoneda(c.monto) }} <small class="ck-recibo__moneda">{{ c.moneda }}</small></div>
                    <div class="ck-recibo__mensaje" *ngIf="c.mensaje">{{ c.mensaje }}</div>

                    <div *ngIf="c.error" class="corp-alert corp-alert-danger ck-recibo__alerta">
                      <i class="bx bx-error-circle corp-alert-icon"></i>
                      <div>{{ c.error }}</div>
                    </div>

                    <dl class="ck-recibo__datos">
                      <div class="ck-recibo__fila" *ngIf="c.fecha">
                        <dt>Fecha</dt>
                        <dd>{{ c.fecha | date:'dd/MM/yyyy HH:mm' }}</dd>
                      </div>
                      <div class="ck-recibo__fila">
                        <dt>Método de pago</dt>
                        <dd>{{ c.metodo }}<span *ngIf="c.tarjeta"> · tarjeta •••• {{ c.tarjeta }}</span></dd>
                      </div>
                      <div class="ck-recibo__fila" *ngIf="c.autorizacion">
                        <dt>Código de autorización</dt>
                        <dd>{{ c.autorizacion }}</dd>
                      </div>
                      <div class="ck-recibo__fila" *ngIf="c.referencia">
                        <dt>Referencia</dt>
                        <dd>{{ c.referencia }}</dd>
                      </div>
                      <div class="ck-recibo__fila" *ngIf="c.idTransaccion">
                        <dt>ID de transacción</dt>
                        <dd>{{ c.idTransaccion }}</dd>
                      </div>
                      <div class="ck-recibo__fila">
                        <dt>Transacción interna</dt>
                        <dd>No. {{ c.transaccion }}</dd>
                      </div>
                      <div class="ck-recibo__fila">
                        <dt>Estado</dt>
                        <dd>
                          <span class="corp-status-badge" [ngClass]="c.aprobado ? 'corp-badge-success' : 'corp-badge-danger'">{{ c.estado }}</span>
                        </dd>
                      </div>
                    </dl>

                    <div class="ck-recibo__acciones">
                      <button type="button" class="corp-btn corp-btn-ghost" (click)="imprimirComprobante()">
                        <i class="bx bx-printer"></i> Imprimir comprobante
                      </button>
                      <button type="button" class="corp-btn corp-btn-primary" (click)="onFinishPay()">
                        <i class="fas fa-check"></i> Volver a mis pagos
                      </button>
                    </div>
                  </div>

                  <div *ngIf="respuestaPago && !comprobante" class="corp-finish-actions ck-recibo__cuerpo">
                    <button class="corp-btn corp-btn-primary" (click)="onFinishPay()">
                      <i class="fas fa-check"></i> Finalizar Pago
                    </button>
                  </div>

                  <div *ngIf="!respuestaPago" class="corp-waiting">
                    <i class="fas fa-spinner fa-spin corp-spinner"></i>
                    <div>Procesando el pago…</div>
                    <div class="ck-recibo__nota">No cierres ni recargues esta ventana.</div>
                  </div>
                </div>

              </ng-template>
            </li>

          </ul>

          <div *ngIf="mensajeError" id="ck-aviso-error" class="ck-aviso" role="alert">
            <i class="bx bx-error-circle ck-aviso__icono"></i>
            <div class="ck-aviso__texto">{{ mensajeError }}</div>
            <button type="button" class="ck-aviso__cerrar" (click)="cerrarError()" aria-label="Cerrar aviso">
              <i class="bx bx-x"></i>
            </button>
          </div>

          <div [ngbNavOutlet]="nav" class="ck-content"></div>
        </div>

        <aside class="ck-summary" aria-label="Resumen del pago">
          <div class="ck-summary__card">
            <h5 class="ck-summary__title">Resumen del pago</h5>

            <details class="ck-summary__detail" open>
              <summary>{{ filtrosList.length }} {{ filtrosList.length == 1 ? 'concepto' : 'conceptos' }}</summary>
              <ul class="ck-summary__list">
                <li *ngFor="let filtro of filtrosList" class="ck-summary__item">
                  <div class="ck-summary__concept">{{ filtro.M54DES }}</div>
                  <div class="ck-summary__amount">{{ simboloMoneda }}{{ formatearMoneda(filtro.M54MON) }}</div>
                </li>
              </ul>
            </details>

            <div class="ck-summary__row" *ngIf="metodoSeleccionadoInfo as pago">
              <div class="ck-summary__label">Método de pago</div>
              <div class="ck-summary__method">
                <img *ngIf="hasLogo(pago.LOGO)" [src]="'data:image/*;base64,' + pago.LOGO" [alt]="pago.FUENTE || 'Logo'">
                <div>{{ pago.DESCRIPCION }}</div>
              </div>
            </div>

            <div class="ck-summary__row" *ngIf="transaccion">
              <div class="ck-summary__label">Transacción</div>
              <div class="ck-summary__value">No. {{ transaccion }}</div>
            </div>

            <div class="ck-summary__total">
              <div class="ck-summary__label">Total a pagar</div>
              <div class="ck-summary__total-value">{{ simboloMoneda }}{{ totalMontoFormateado }}</div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  </div>
</div>